import { Firebase } from "@/app/core/base/FirebaseApp";
import { toast } from "react-toastify";
import {
  getFirestore,
  collection,
  getDocs,
  updateDoc,
  doc,
  getDoc,
  Timestamp,
  getCountFromServer,
  query,
  where,
  addDoc,
  startAt,
  endAt,
} from "firebase/firestore";
import { ErrorHelper } from "../../util/helpers/ErrorHelper";
import { FireHelper } from "../../util/helpers/FireHelper";
import { DateHelper } from "../../util/helpers/DateHelper";
import algoliasearch from "algoliasearch";
import { CompanyHelper } from "../../util/helpers/CompanyHelper";

export const CompanyController = {
  db: getFirestore(Firebase),

  ToFirestoreCompany: function (data) {
    let updatedData = {
      bio: data.bio,
      id: data.id,
      logo: data.logo,

      name: data.name,
      realName: data.realName,
      taxId: data.taxId,
      phone: data.phone,
      email: data.email,
      website: data.website,
      verified: data.verified,

      postalCode: data.postalCode,
      neighborhood: data.neighborhood,
      state: data.state,
      street: data.street,
      city: data.city,
      status: data.status ?? CompanyHelper.Status.Pending,
      stamp: data.stamp ?? CompanyHelper.Stamp.None,
      oldId: data.oldId ?? 0,

      createdDate: data.createdDate ?? Timestamp.now(),
      updatedDate: Timestamp.now(),
    };
    return FireHelper.ToFirestoreDoc(updatedData);
  },

  Insert: async function (data) {
    try {
      const coll = collection(this.db, "companies");
      const result = await addDoc(coll, this.ToFirestoreCompany(data));
      return result.id;
    } catch (e) {
      console.log("CompanyController insert error", e);
      toast.error(ErrorHelper.HandleMessage(e));
      return null;
    }
  },

  Update: async function (data) {
    try {
      const frankDocRef = doc(this.db, "companies", data.id);
      await updateDoc(frankDocRef, this.ToFirestoreCompany(data));
    } catch (e) {
      console.log("CompanyController: ", e);
      toast.error(ErrorHelper.HandleMessage(e));
    }
  },

  Get: async function (id) {
    const docRef = doc(this.db, "companies", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { ...docSnap.data(), id: id };
    } else {
      return null;
    }
  },

  List: async function () {
    let companiesQuery = collection(this.db, "companies");

    // if (status != undefined && typeof status === "number") {
    //   companiesQuery = query(companiesQuery, where("status", "==", status));
    // }

    const querySnapshot = await getDocs(companiesQuery);
    const results = querySnapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));

    return results;
  },
  
  ListByPage: async function ({ page }) {
    let companiesQuery = collection(this.db, "companies");

    if (typeof page === "number") {
      companiesQuery = query(companiesQuery, startAt(page), endAt(page*10));
    }

    const querySnapshot = await getDocs(companiesQuery);
    const results = querySnapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));

    return results;
  },

  
  ListByDate: async function (startDate, endDate) {
    const usersQuery = query(
      collection(this.db, "companies"),
      where("createdDate", ">=", Timestamp.fromDate(startDate)),
      where("createdDate", "<=", Timestamp.fromDate(endDate))
    );

    // Process the documents to group by month
    const querySnapshots = await getDocs(usersQuery);

    const results = querySnapshots.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));

    return results;
  },

  Query: async function ({ queryString, hitsPerPage }) {
    const searchClient = algoliasearch(
      "Y67ZPH9IGB",
      "a160a59d07299b8cdf05130b672ff01e"
    );

    let index = searchClient.initIndex("companies_search_index");
    const { hits } = await index.search(queryString, {
      hitsPerPage: hitsPerPage || 100,
    });

    return hits.map((doc) => ({ ...doc, id: doc.objectID }));
  },

  GetTotalCount: async function () {
    const coll = collection(this.db, "companies");
    const snapshot = await getCountFromServer(coll);
    return snapshot.data().count;
  },

  QueryCompanies: async function (localIds) {
    console.log(localIds);
    const batchSize = 30;
    let results = [];

    for (let i = 0; i < localIds.length; i += batchSize) {
        const batch = localIds.slice(i, i + batchSize);
        const usersQuery = query(
            collection(this.db, "companies"),
            where("id", "in", batch)
        );

        const querySnapshots = await getDocs(usersQuery);
        const batchResults = querySnapshots.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        }));

        results = results.concat(batchResults);
      }

    return results;
  },

  GetReportsByDate: async function (startDate, endDate) {
    const companiesQuery = query(
      collection(this.db, "companies"),
      where("createdDate", ">=", Timestamp.fromDate(startDate)),
      where("createdDate", "<=", Timestamp.fromDate(endDate))
    );

    // Initialize a dictionary to hold counts for each month-year in the range
    const countsByMonth = {};

    // Generate all months between startDate and endDate
    let currentMonth = DateHelper.GetFirstDayOfMonthByDate(startDate);
    while (currentMonth <= endDate) {
      const year = currentMonth.getFullYear();
      const month = currentMonth.getMonth();
      const monthYear = `${year}-${month.toString().padStart(2, "0")}`;
      countsByMonth[monthYear] = {
        year: year,
        month: month,
        ativos: 0,
        inativas: 0,
      };
      currentMonth = DateHelper.AddMonths(currentMonth, 1);
    }

    // Process the documents to group by month
    (await getDocs(companiesQuery)).forEach((doc) => {
      const createdDate = doc.data().createdDate.toDate();
      const year = createdDate.getFullYear();
      const month = createdDate.getMonth();
      const monthYear = `${year}-${month.toString().padStart(2, "0")}`;

      // Increment count for the corresponding month
      const currentValue = countsByMonth[monthYear];
      if (currentValue !== undefined) {
        if (doc.data().active === true) {
          currentValue.ativos += 1;
        } else {
          currentValue.inativas += 1;
        }
      }
    });

    // Convert countsByMonth to an array of objects
    const result = Object.keys(countsByMonth).map((key) => ({
      ...countsByMonth[key],
    }));

    return result;
  },
};
